<template>
  <div class="loading-box">
    <van-overlay :show="show" z-index="10241" />
    <van-loading v-if="show" size="50px" color="#F0F8FF" vertical>加载中...</van-loading>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['show']
}
</script>

<style lang="scss">
.loading-box {
  display: flex;
  justify-content: center;
  .van-loading {
    z-index: 10242;
    position: absolute;
    top: 40%;
    .van-loading__text {
      color: #F0F8FF;
    }
  }
}
</style>
